import {
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import { Form } from "react-bootstrap";

interface ModelInfoSelectObjectProps {
  name: string;
  attributes: any[];
  initialValue: string | number | undefined;
  currentValue: string | number | undefined;
  isNumbersOnly: boolean;
  isOptional: boolean;
  disabled: boolean;
  attributeId: string;
  attributeField: string;
  value: any;
  alternativeValue: string;
  onChange: (value: string | number) => void;
}

function ModelInfoSelectObject({
  name,
  attributes,
  initialValue,
  currentValue,
  isNumbersOnly,
  isOptional,
  disabled,
  attributeId,
  attributeField,
  value,
  alternativeValue,
  onChange,
}: ModelInfoSelectObjectProps) {
  const [isModified, setIsModified] = useState(false);
  const selectRef = useRef<HTMLSelectElement | null>(null);
  const [width, setWidth] = useState<number>();

  useEffect(() => {
    setIsModified(currentValue !== initialValue);
  }, [currentValue, initialValue]);

  var ctx = (document.createElement("canvas") as HTMLCanvasElement).getContext(
    "2d",
  );

  const calcWidth = useCallback(() => {
    if (selectRef?.current) {
      if (ctx) {
        const computedStyle = window.getComputedStyle(selectRef.current);
        ctx.font = computedStyle.font;
        const textSize = ctx.measureText(
          selectRef.current.options[selectRef.current.selectedIndex].innerText,
        );

        return (
          textSize.width +
          parseFloat(computedStyle.paddingLeft) +
          parseFloat(computedStyle.paddingRight) +
          parseFloat(computedStyle.borderLeftWidth) +
          parseFloat(computedStyle.borderRightWidth)
        );
      }
    }

    return undefined;
  }, [ctx]);

  useLayoutEffect(() => {
    setWidth(calcWidth());
  }, [calcWidth]);

  return (
    <Form.Select
      className={isModified ? "border-3 border-warning" : ""}
      name={name}
      value={value}
      disabled={disabled}
      size="sm"
      onChange={(e) => {
        setIsModified(e.target.value !== initialValue);
        onChange(isNumbersOnly ? parseInt(e.target.value) : e.target.value);
      }}
      ref={selectRef}
      style={{ width: "100%", minWidth: width }}
    >
      {isOptional && (
        <option key={undefined} value={undefined}>
          [None]
        </option>
      )}
      {attributes?.map((attribute) => (
        <option
          key={attribute[`${attributeId}`]}
          value={attribute[`${attributeId}`]}
        >
          {attribute[`${attributeField}`]
            ? attribute[`${attributeField}`]
            : alternativeValue}
        </option>
      ))}
    </Form.Select>
  );
}

export default ModelInfoSelectObject;
